import jsPDF from "jspdf";
import { ProductOrder } from "../types/admin/productOrder.types";

export const downloadProductOrderPDF = (order: ProductOrder) => {
  const pdf = new jsPDF("p", "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();

  let y = 20;

  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(20);
  pdf.text("Autocare", pageWidth / 2, y, { align: "center" });

  y += 10;

  pdf.setFontSize(12);
  pdf.text("Product Order Details", pageWidth / 2, y, {
    align: "center",
  });

  y += 10;
  pdf.line(15, y, pageWidth - 15, y);
  y += 10;

  pdf.setFontSize(10);
  pdf.setFont("helvetica", "normal");

  pdf.text(`Order ID: ${order._id}`, 15, y);
  pdf.text(`Order Date: ${order.createdAt.split("T")[0]}`, pageWidth - 15, y, {
    align: "right",
  });

  y += 6;
  pdf.text(`Status: ${order.status}`, 15, y);
  pdf.text(
    `Expected Delivery: ${order.expectedDelivery.split("T")[0]}`,
    pageWidth - 15,
    y,
    { align: "right" },
  );

  y += 12;

  pdf.setFont("helvetica", "bold");
  pdf.text("Delivery Details", 15, y);
  y += 6;

  pdf.setFont("helvetica", "normal");
  pdf.text(`City: ${order.city}`, 15, y);
  y += 8;

  pdf.setFont("helvetica", "bold");
  pdf.text("Customer", 15, y);
  y += 6;

  pdf.setFont("helvetica", "normal");
  pdf.text(order.user?.name || order.userId, 15, y);
  y += 6;

  if (order.user?.phone) {
    pdf.text(`Phone: ${order.user.phone}`, 15, y);
    y += 6;
  }

  if (order.user?.email) {
    pdf.text(`Email: ${order.user.email}`, 15, y);
    y += 6;
  }

  y += 10;

  pdf.setFont("helvetica", "bold");
  pdf.text("Item", 15, y);
  pdf.text("Qty", pageWidth - 45, y, { align: "right" });
  pdf.text("Price", pageWidth - 15, y, { align: "right" });

  y += 2;
  pdf.line(15, y, pageWidth - 15, y);
  y += 6;

  pdf.setFont("helvetica", "normal");

  const itemName = order.product?.name || "Product";

  pdf.text(itemName, 15, y);
  pdf.text(String(order.quantity), pageWidth - 45, y, {
    align: "right",
  });
  pdf.text(`Rs. ${order.price}`, pageWidth - 15, y, {
    align: "right",
  });

  y += 10;
  pdf.line(15, y, pageWidth - 15, y);
  y += 8;

  pdf.setFont("helvetica", "bold");
  pdf.text("Total", 15, y);
  pdf.setFontSize(14);
  pdf.text(`Rs. ${order.price}`, pageWidth - 15, y, {
    align: "right",
  });

  pdf.setFontSize(9);
  pdf.setFont("helvetica", "normal");
  pdf.text("Thanks for choosing Autocare", pageWidth / 2, 285, {
    align: "center",
  });

  pdf.save(`product-order-${order._id}.pdf`);
};
